import GameState from "slotworks/model/game-state";
import { Exit } from "slotworks/state-machine/data/exit";
import Decision from "slotworks/state-machine/decisions/decision";
import ICSpinRecord from "integration/revolver/schema/spin-record";
import ICFreespinRecord from "integration/revolver/schema/freespin-record";
import BonusRecord from "integration/revolver/schema/bonus-record";
import betModel from "slotworks/model/bets/bet-model";

export default class IsJackpotDecision extends Decision {
    public evaluate() {
        const icrecord = GameState.getCurrentGame().latestRecord() as ICSpinRecord | ICFreespinRecord;
        if(icrecord.isJackpotWon)
            return Exit.True;  
        
        // const last = GameState.getCurrentGame().getCurrentRecord();
        // let bonusRecord: BonusRecord;
        // if(last instanceof ICFreespinRecord) {
        //     const prev = GameState.getCurrentGame().getPreviousRecord();
        //     if(prev instanceof BonusRecord) {
        //         bonusRecord = prev as BonusRecord;
        //     } else
        //         return Exit.False;
        // } else 
        //     bonusRecord = last as BonusRecord;
            
        // const stake = betModel.getTotalBet();
        // const won = bonusRecord.creditsWon;
        // const awardedMultiplier = bonusRecord.awardedMultiplier;
        // // todo correct server data pls
        // if(awardedMultiplier === 2000 ||  won / stake >= 2000)
        //     return Exit.True;

        return Exit.False;
    }
}